import { render, staticRenderFns } from "./Dasboard.vue?vue&type=template&id=5e4f4972"
import script from "./Dasboard.vue?vue&type=script&lang=js"
export * from "./Dasboard.vue?vue&type=script&lang=js"
import style0 from "./Dasboard.vue?vue&type=style&index=0&id=5e4f4972&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports